module.exports = __webpack_public_path__ + "images/emoji/monkey.cb1a1db54417280198fb.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/monkey.png
// module id = Buyo
// module chunks = 1